import instance from '../instance'

export function login(email, password) {
    return instance.post('/authentication/login', {email, password})
}

export function forgot(email) {
    return instance.post('/authentication/forgot_password', {email})
}

export function first_login(email, old_password, new_password, new_password_confirmation) {
    return instance.post('/authentication/first_login', {email, old_password, new_password, new_password_confirmation})
}

export function change_password(password, new_password, new_password_confirmation) {
    return instance.post('/authentication/change_password', {password, new_password, new_password_confirmation})
}


export function auth() {
    return instance.post('/auth')
}
